import React, { useState } from 'react'
import adminStyles from './adminStyles.module.css'
import axios from 'axios'

const AddTreatment = () => {
  const [image,setImage]=useState("");
  const[tname,setTname]=useState("");
  const[tdesc,setTdesc]=useState("");
  const formdata=new FormData();
  
  const addTreatmentData=(e)=>{
    e.preventDefault();
    formdata.append("image",image);
    formdata.append("tname",tname);
    formdata.append("tdesc",tdesc);

        axios.post(`https://backendsurgylife-1.onrender.com/uploads/`,formdata)
          .then((res)=>{
              alert(" Treatment Added Successfully");
              setImage("");
              setTname("");
              setTdesc("");
          })
          .catch((err)=>{
           console.error("Error while adding  Treatment:",err);
          });
  }

  return (
    <main>
    
            <section >
              <div className='container'>
                <div className='row'>
                  <div className='col-md-8 '>
                    <div className={adminStyles.bx_shadow}>
                    <form onSubmit={addTreatmentData}>

                      <div className='mb-3'>
                          <input type='file'
                          className='form-control'
                          onChange={(e)=>setImage(e.target.files[0])}
                          />
                         
                      </div>

                        <div className='mb-3'>
                          <input type='text' 
                          name='tname'
                          placeholder='T.Name' 
                          className='form-control '
                          value={tname}
                          onChange={
                            (e)=>setTname(e.target.value)
                          }
                          />
                      </div>
                             <div className='mb-3'>
                          <input type='text' 
                          name='tdesc'
                          placeholder='T.Desc' 
                          className='form-control '
                          value={tdesc}
                          onChange={
                            (e)=>setTdesc(e.target.value)
                          }
                          />
                      </div>
                        
                      
                        <div className='mb-3'>
                          <input type='submit'  
                          className='btn btn-success '
                          value='Add Treatment'
                          />
                      </div>

                    </form>
                    </div>
                  </div>
                </div>
              </div>
            </section>

    </main>
  )
}

export default AddTreatment
